import React from 'react';
import { OuterFooterButtonContainer, OuterFooterContainer, OuterFooterPriceContainer } from './OuterFooter-styled';
import { FullscreenExitOutlined, FullscreenOutlined, ShareAltOutlined } from '@ant-design/icons';


interface Props {
  modelFullscreen:boolean,
  onShareButtonClick:()=>void,
  setModelFullscreen:(value:boolean)=>void,
  price:number,
  mobile:boolean,
  menuHeight:number,
  menuScaleFactor:number
}

export class OuterFooter extends React.Component<Props,{}> {
  constructor(props) {
    super(props)
  }

  public render = () => {
    const { modelFullscreen, onShareButtonClick, setModelFullscreen, price, mobile, menuScaleFactor } = this.props;

    return (
      <OuterFooterContainer modelFullscreen={modelFullscreen} mobile={mobile} menuScaleFactor={menuScaleFactor}>
        {mobile && !modelFullscreen &&
          <OuterFooterPriceContainer>${price.toLocaleString('en-US')}</OuterFooterPriceContainer>
        }

        {!modelFullscreen &&
          <OuterFooterButtonContainer
            onClick={onShareButtonClick}
          >
            <ShareAltOutlined/>
          </OuterFooterButtonContainer>
        }
        
        <OuterFooterButtonContainer
          onClick={() => setModelFullscreen(!modelFullscreen)}
        >
          {!modelFullscreen && <FullscreenOutlined/>}
          {modelFullscreen && <FullscreenExitOutlined/>}
        </OuterFooterButtonContainer>
      </OuterFooterContainer>
    )
  }
}